import React from 'react';

export default function Login() {
  return (
    <div style={{
      height: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 20,
      background: 'var(--bg-app, #f7f7f8)'
    }}>
      <div style={{
        width: 44, height: 44, background: 'var(--accent)', borderRadius: 12,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 20, fontWeight: 700, fontFamily: 'Syne, sans-serif', color: '#fff'
      }}>P</div>
      <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 20 }}>PitchFlow</div>
      <div style={{ fontSize: 13, color: 'var(--text-muted, #888)' }}>Sign in with your ophalai.com account to continue.</div>
      <a href="/api/auth/login" style={{
        marginTop: 8, padding: '10px 20px', borderRadius: 8, background: 'var(--accent)',
        color: '#fff', textDecoration: 'none', fontSize: 14, fontWeight: 600
      }}>Sign in with Google</a>
    </div>
  );
}
